import { useEffect, useState } from "react";
import { MainWrapper } from "../../common/MainWrapper";
import Header from "../../common/Header";
import axios from "axios";
import { LinkDelete, LinkShow, TableWrapper, StyledMainTitle } from "../styled";
import { BackToPanel } from "../../common/BackToPanel";
import ScrollButton from "../scrollButton";
import { baseUrl } from "../../common/apiUrl";

const ArchStatmentList = ({ user }) => {
  const [item, setItem] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);

  useEffect(() => {
    loadStatments();
  }, []);

  const loadStatments = async () => {
    const response = await axios.get(`${baseUrl}/archStatments.php`);
    setItem(response.data);
  };

  const deleteAndRefresh = (id) => {
    deleteStatment(id);
    reload();
  };

  const reload = () => {
    window.location.reload();
  };

  const deleteStatment = (id) => {
    axios
      .delete(`${baseUrl}/deleteArchStatment.php`, {
        data: { id: id },
      })
      .then(() => {
        alert("Are you sure to delete this Statment?");
      })
      .catch(() => {
        alert("Error in the Code");
      });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = item.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate page numbers
  const pageNumbers = [];
  const totalPages = Math.ceil(item.length / itemsPerPage);
  const maxVisiblePages = 3;
  let startPage, endPage;

  if (totalPages <= maxVisiblePages) {
    // Display all pages if total pages are less than or equal to max visible pages
    startPage = 1;
    endPage = totalPages;
  } else {
    // Calculate start and end page to limit the number of visible pages
    const maxVisiblePagesBeforeCurrent = Math.floor(maxVisiblePages / 2);
    const maxVisiblePagesAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;

    if (currentPage <= maxVisiblePagesBeforeCurrent) {
      // Current page is near the start
      startPage = 1;
      endPage = maxVisiblePages;
    } else if (currentPage + maxVisiblePagesAfterCurrent >= totalPages) {
      // Current page is near the end
      startPage = totalPages - maxVisiblePages + 1;
      endPage = totalPages;
    } else {
      // Current page is in the middle
      startPage = currentPage - maxVisiblePagesBeforeCurrent;
      endPage = currentPage + maxVisiblePagesAfterCurrent;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <Header user={user} />
      <ScrollButton />
      <MainWrapper>
        <StyledMainTitle>Lista archiwalnych zestawień</StyledMainTitle>
        <BackToPanel />
        <TableWrapper>
          <table className="table table-dark table-striped table-bordered table-modified">
            <thead>
              <tr>
                <td>#</td>
                <td>Data od</td>
                <td>Data do</td>
                <td>Przejdź do zestawienia</td>
                <td>Usuń zestawienie</td>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.date_from}</td>
                    <td>{item.date_to}</td>
                    <td>
                      <LinkShow to={`/archstatment/${item.id}`}>
                        Show Statment
                      </LinkShow>
                    </td>
                    <td>
                      <LinkDelete
                        to=""
                        onClick={() => deleteAndRefresh(item.id)}
                      >
                        Delete
                      </LinkDelete>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </TableWrapper>
        <nav>
          <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
              >
                First
              </button>
            </li>
            {currentPage > 1 && (
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
            )}
            {pageNumbers.map((pageNumber) => (
              <li
                key={pageNumber}
                className={`page-item ${
                  pageNumber === currentPage ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => paginate(pageNumber)}
                >
                  {pageNumber}
                </button>
              </li>
            ))}
            {currentPage < totalPages && (
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            )}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
              >
                Last
              </button>
            </li>
          </ul>
        </nav>
      </MainWrapper>
    </>
  );
};

export default ArchStatmentList;
